import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, MenuItem, Typography } from "@mui/material";
import FormInput from "components/forminput";
import SelectState from "components/selectstate";
import SelectCity from "components/selectcity";
import { useAuth } from "hooks/useUser";
import { Formik } from "formik";
import { number, object, string } from "yup";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const ageOptions = [
  { key: "Under_18", value: "Under 18" },
  { key: "Between_18_And_24", value: "Between 18 And 24" },
  { key: "Between_25_And_34", value: "Between 25 And 34" },
  { key: "Between_35_And_44", value: "Between 35 And 44" },
  { key: "Between_45_And_54", value: "Between 45 And 54" },
  { key: "ABOVE_55", value: "Above 55" },
] as const;

const genderOptions = [
  { key: "Male", value: "Male" },
  { key: "Female", value: "Female" },
  { key: "Others", value: "Others" },
  { key: "PreferNotToAnswer", value: "Prefer not to answer" },
] as const;
const validationSchema = object({
  firstName: string().required("First Name is required"),
  lastName: string().required("Last Name is required"),
  email: string().required(),
  countryName: string().required("Country is required"),
  stateId: number().required("State is required"),
  phoneNumber: string().required("Phone Number is required"),
  address: string().optional(),
  age: string()
    .oneOf(ageOptions.map(({ key }) => key))
    .required(),
  gender: string()
    .oneOf(genderOptions.map(({ key }) => key))
    .required(),
});

async function updateInfo(input: ReturnType<typeof validationSchema.cast>) {
  const { data } = await axios.patch("/auth/agent/profile", input);
  return data;
}

function Setup() {
  const { data } = useAuth();
  const navigate = useNavigate();
  const update = useMutation(updateInfo, {
    onSuccess() {
      navigate("/setup/two");
    },
  });
  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "grid",
          gridTemplateColumns: "auto 1fr auto",
        }}>
        <Typography variant="h6" align="center" component="p">
          Account Setup
        </Typography>
        <Typography alignSelf="center" color="primary">
          1/3
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            countryName: data.countryName || "Nigeria",
            stateId: data.stateId || undefined,
            phoneNumber: data.phoneNumber || "",
            address: data.address || "",
            age: data.age || "",
            gender: data.gender || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(data) => {
            update.mutate(data);
          }}>
          {({ handleBlur, handleSubmit, handleChange, setFieldValue, touched, values, errors }) => (
            <Box component="form" onSubmit={handleSubmit}>
              <Grid container rowSpacing={1} columnSpacing={4}>
                <Grid item xs={12} md={6}>
                  <FormInput
                    id="firstName"
                    onChange={handleChange}
                    value={values.firstName}
                    label="First Name"
                    name="firstName"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormInput
                    id="lastName"
                    onChange={handleChange}
                    value={values.lastName}
                    label="Last Name"
                    name="lastName"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormInput id="email" label="Email" name="email" onChange={handleChange} value={values.email} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormInput
                    id="phoneNumber"
                    onChange={handleChange}
                    value={values.phoneNumber}
                    label="Phone number"
                    name="phoneNumber"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormInput
                    id="address"
                    onChange={handleChange}
                    value={values.address}
                    label="Address"
                    name="address"
                    multiline
                    minRows={2}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SelectState
                    id="state"
                    value={values.stateId}
                    label="State"
                    name="stateId"
                    onChange={(value) => {
                      setFieldValue("stateId", value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SelectCity
                    name="cityId"
                    label="City"
                    id="city"
                    stateId={values.stateId}
                    onChange={(value) => {
                      console.log({ value });
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormInput id="age" value={values.age} onChange={handleChange} label="Age" name="age" select>
                    {ageOptions.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </FormInput>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormInput
                    id="gender"
                    onChange={handleChange}
                    value={values.gender}
                    label="Gender"
                    name="gender"
                    select>
                    {genderOptions.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </FormInput>
                </Grid>
              </Grid>
              <Button fullWidth type="submit" variant="contained" size="large" sx={{ mt: 4 }}>
                Continue
              </Button>
              <Button
                type="button"
                onClick={() => {
                  navigate("/dashboard/home");
                }}
                fullWidth
                variant="text"
                size="large"
                sx={{ mb: 4 }}>
                I'll do this later
              </Button>
            </Box>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

export default Setup;
